import { render, staticRenderFns } from "./newSchemeDetails.vue?vue&type=template&id=62b5687c"
import script from "./newSchemeDetails.vue?vue&type=script&lang=js"
export * from "./newSchemeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports